import React,{Component} from 'react';
import { connect } from "react-redux";
import {Navbar,Nav,NavbarBrand,NavItem} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import './tradesmen.png'
import './Toolbar.css';
import './Toolbar-responsive.css';
import logo from './TI_LOGO_Clear_157x55.png';
const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URLDEPLOY;
const API_SERVER_PORT = process.env.REACT_APP_API_DEPLOY_PORT;

class Toolbar extends Component {


  render(){
  return(
  <Navbar className="toolbar">
    <NavbarBrand to="/">
      <img src={logo} alt="logo"/>
    </NavbarBrand>
    <Nav className="ml_auto" style={{paddingRight: '15px'}}>
      {/* <NavItem className="toolbar_navigation-items user active"><NavLink activeStyle={{color:"red"}} to="/" className="nav-link"><span className="sr-only">(current)</span><i className="fas fa-home"></i></NavLink></NavItem> */}
      {/* <li className="bar1"></li> */}
      {/* <NavItem className="toolbar_navigation-items user"><NavLink to="/profile" className="nav-link"><i className="fas fa-user"></i></NavLink></NavItem> */}
      
      {/* <div className="toolbar_navigation-items user" >
          <div className="nav-link">
            <i className="fas fa-power-off" />
          </div>
      </div> */}
      
    </Nav>
  </Navbar>
);

    }}


// function mapStateToProps(state) {
//   return {
//     keycloak: state.authInfo.keycloak,
//   };
// }
export default (Toolbar);